import React from 'react';
import Question from './Question';

class ListOfRequirements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: []
        }
    }

    componentWillMount() {
        let id = this.props.licenseTypeID;
        fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/questions`)
            .then(function (response) {
                // console.log(response)
                return response.json();
            })
            .then((data) => {
                console.log(data);
                this.setState({
                    questions: data.Questions
                })
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        let questions = this.props.questions;
        if (this.props.filteredStates.length !== 0) {
            const filteredStatesQuestions = this.props.filteredStates
                .map(state => state.questionIds.split(',')
                .map(n => Number(n)))
                .reduce((prev, curr) => prev.concat(curr))
            questions = questions.map(question => {
                if(filteredStatesQuestions.indexOf(question.Id) > -1) {
                    return {
                        ...question,
                        highlight: true
                    };
                } else {
                    return question;
                }
            });
        }


        return (
            <Question questions={questions} key={questions.Id} />
        );
    }

}


export default ListOfRequirements;



// WEBPACK FOOTER //
// ./src/components/Requirements.js